(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6666],{

/***/ 6666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28447);
/* harmony import */ var _ab_history_menu_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61426);
/* harmony import */ var _ab_history_menu_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_history_menu_scss__WEBPACK_IMPORTED_MODULE_3__);




var HistoryMenu = function(param) {
    var links = param.links, white = param.white;
    // const [selected, setSelected] = useState('false');
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_2__/* .useInViewport */ .NM)(myRef, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref.inViewport, enterCount = ref.enterCount, leaveCount = ref.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#tierras");
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    document.getElementById("history-menu").scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    // console.log('HistoryMenu', links);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "reference-tierras",
                id: "tierras"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ab-historia-menu".concat(white ? " white" : ""),
                id: "ab-historia-menu",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        id: "history-menu",
                        children: links === null || links === void 0 ? void 0 : links.map(function(itm) {
                            var ref, ref1, ref2, ref3;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                // className={selected == itm?.link?.url ? 'selected' : 'not-selected'}
                                id: "menu-".concat(itm === null || itm === void 0 ? void 0 : (ref = itm.link) === null || ref === void 0 ? void 0 : ref.url),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: itm === null || itm === void 0 ? void 0 : (ref1 = itm.link) === null || ref1 === void 0 ? void 0 : ref1.url,
                                    children: itm === null || itm === void 0 ? void 0 : (ref2 = itm.link) === null || ref2 === void 0 ? void 0 : ref2.title
                                })
                            }, "menu-".concat(itm === null || itm === void 0 ? void 0 : (ref3 = itm.link) === null || ref3 === void 0 ? void 0 : ref3.url));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "tierras",
                ref: myRef
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HistoryMenu);


/***/ }),

/***/ 61426:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);